// extracted by mini-css-extract-plugin
export default {"mainContainer":"aluno_mainContainer__R0fRg","background":"aluno_background__-PBJA","row":"aluno_row__A58cy"};